module.exports = __webpack_public_path__ + "static/media/sculpture-3.f10d9bae.jpg";